import { useEffect, useState } from 'react'
import { api } from '../lib/api'

export default function ClassesPage() {
  const [classes, setClasses] = useState<any[]>([])
  const [bookings, setBookings] = useState<any[]>([])

  useEffect(() => {
    api.getClasses().then(({ classes }) => setClasses(classes)).catch(() => {})
    api.getMyBookings().then(({ bookings }) => setBookings(bookings)).catch(() => {})
  }, [])

  const bookedIds = new Set(bookings.map(b => b.classId))

  async function handleBook(classId: string) {
    try {
      await api.bookClass(classId)
      api.getMyBookings().then(({ bookings }) => setBookings(bookings))
      api.getClasses().then(({ classes }) => setClasses(classes))
    } catch (err: any) {
      alert(err.message)
    }
  }

  async function handleCancel(classId: string) {
    try {
      await api.cancelBooking(classId)
      api.getMyBookings().then(({ bookings }) => setBookings(bookings))
      api.getClasses().then(({ classes }) => setClasses(classes))
    } catch (err: any) {
      alert(err.message)
    }
  }

  return (
    <div>
      <div className="page-header">
        <h2>Bootcamp Classes</h2>
        <p>$5 per session · No contracts · Just bring water and a smile</p>
      </div>

      {/* Default class info */}
      <div className="card" style={{ borderColor: 'var(--gold)', marginBottom: '1.5rem' }}>
        <div className="card-title" style={{ marginBottom: '0.75rem' }}>📍 Home Base</div>
        <p><strong>Location:</strong> 3001 Azle Avenue, Fort Worth, TX</p>
        <p><strong>Schedule:</strong> Monday–Friday, 6:30 PM – 7:30 PM</p>
        <p><strong>Price:</strong> $5 per session · First class FREE</p>
        <p style={{ marginTop: '0.5rem', color: 'var(--text-secondary)', fontStyle: 'italic' }}>
          All equipment provided. Every age, every fitness level, every background welcome.
        </p>
      </div>

      {/* Upcoming classes */}
      <div className="card">
        <div className="card-header">
          <span className="card-title">Upcoming Classes</span>
        </div>
        {classes.length === 0 ? (
          <p style={{ color: 'var(--text-secondary)', textAlign: 'center', padding: '2rem 0' }}>
            No upcoming scheduled classes. Drop in at our regular weekday sessions!
          </p>
        ) : (
          classes.map(c => {
            const booked = bookedIds.has(c.id)
            const start = new Date(c.startsAt)
            return (
              <div key={c.id} className="quest-item">
                <span className="quest-icon">📅</span>
                <div className="quest-info">
                  <div className="quest-name">{c.title}</div>
                  <div style={{ fontSize: '0.8rem', color: 'var(--text-secondary)' }}>
                    {start.toLocaleDateString()} · {start.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} · {c.spotsAvailable} spots left
                  </div>
                </div>
                {booked ? (
                  <button className="btn btn-secondary" style={{ padding: '0.4rem 0.8rem', fontSize: '0.75rem' }} onClick={() => handleCancel(c.id)}>
                    Cancel
                  </button>
                ) : (
                  <button className="btn btn-primary" style={{ padding: '0.4rem 0.8rem', fontSize: '0.75rem' }} onClick={() => handleBook(c.id)}>
                    Book
                  </button>
                )}
              </div>
            )
          })
        )}
      </div>
    </div>
  )
}
